import React from 'react';
import { useTranslation } from 'react-i18next';
import { SensorTemp } from '../../../Model/sensorTemp';
import { SensorsImportResponse } from '../../../Model/SensorsImportResponse';
import constants from '../../../constants';
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Button,
  Select,
  MenuItem,
  InputLabel
  // eslint-disable-next-line import/no-extraneous-dependencies
} from '@mui/material';

interface Props {
  importCSV: Function;
  setCsvString: Function;
  validateCSVFile: Function;
  setCsvFile: Function;
  setSelectedProductType: Function;
  sensorsTypes: any[];
  importCSVResult: string | undefined;
  importOverView: SensorsImportResponse | undefined;
  showSensorsList: Function;
  showSensorList: string | undefined;
  setShowSkippedDetails: Function;
  showSkippedDetails: boolean;
  selectedProductType: string | undefined;
  csvFile: File | undefined;
  invalidCsvFile: boolean | undefined;
}
const ImportCsv = ({
  importCSV,
  setCsvString,
  validateCSVFile,
  setCsvFile,
  setSelectedProductType,
  sensorsTypes,
  importCSVResult,
  importOverView,
  showSensorsList,
  showSensorList,
  setShowSkippedDetails,
  showSkippedDetails,
  selectedProductType,
  csvFile,
  invalidCsvFile
}: Props) => {
  console.log('ma quindi? ------- ',   selectedProductType === undefined ||
  csvFile === undefined ||
  invalidCsvFile);
  console.log('selectedProductType ---', selectedProductType);
  console.log('csvFile ----', csvFile);
  console.log('invalidCsvFile ----', invalidCsvFile);
  const { t } = useTranslation();
  return (
    <Card
      sx={{
        width: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 5
      }}
    >
      <CardHeader
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.03)' }}
        subheader={t('IMPORT_CSV')}
      ></CardHeader>
      <CardContent style={{ marginTop: 10 }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputLabel className='inputLabel'> {t('IMPORT_SENSORS_CSV')}</InputLabel>
            <Button variant="contained" component="label">
              Upload
              <input
                id="import-csv"
                hidden
                accept=".csv"
                multiple
                type="file"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  console.log(e, e.target.files);
                  const csvFileValue = (e.target.files || [])[0];
                  if (csvFileValue) {
                    const reader = new FileReader();
                    reader.onload = () => {
                      const csvStringValue = reader.result as string;
                      setCsvString(csvStringValue);
                      validateCSVFile(csvStringValue);
                    };
                    reader.readAsBinaryString(csvFileValue);
                  }
                  setCsvFile(csvFileValue);
                }}
              />
            </Button>{' '}
            {csvFile?.name}
            <div>
              <a
                href={constants.add_sensors.importCSVSensorsSample}
                /* eslint-disable react/no-unknown-property */
                download={'import-sensors-sample.csv'}
              >
                <small>{t('DOWNLOAD_IMPORT_CSV_SAMPLE')}</small>
              </a>
            </div>
          </Grid>
          <Grid item xs={6}>
            <InputLabel className='inputLabel'>{t('SELECT_PRODUCTS_TYPES')}</InputLabel>
            <Select
              sx={{
                '& legend': { display: 'none' },
                '& fieldset': { top: 0 }
              }}
              fullWidth
              size="small"
              onChange={(e) => {
                setSelectedProductType(e.target.value);
              }}
            >
              <MenuItem value={''}>-</MenuItem>
              {sensorsTypes.map((st: any) => (
                <MenuItem key={st.code} value={st.code}>
                  {st.friendlyName}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>

        {importCSVResult && (
          <>
            <h3>Error</h3>
            <p>{importCSVResult}</p>
          </>
        )}
        {importOverView && (
          <>
            <table
              className="no-padding default"
              style={{ marginTop: '1.5em' }}
            >
              <thead>
                <tr>
                  <th colSpan={3}>
                    <h5>{t('SENSORS_IMPORT_RESULT')}</h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>{t('IMPORTED_SENSORS')}</th>
                  <td>{importOverView.overviewCounts.inserted}</td>
                  <td>
                    <a onClick={() => showSensorsList('inserted')}>
                      {t(
                        showSensorList === 'inserted'
                          ? 'HIDE_DETAILS'
                          : 'SHOW_DETAILS'
                      )}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th>{t('UPDATED_SENSORS')}</th>
                  <td>{importOverView.overviewCounts.updated}</td>
                  <td>
                    <a onClick={() => showSensorsList('updated')}>
                      {t(
                        showSensorList === 'updated'
                          ? 'HIDE_DETAILS'
                          : 'SHOW_DETAILS'
                      )}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th>{t('NOT_UPDATED_SENSORS')}</th>
                  <td>{importOverView.overviewCounts.alreadyInserted}</td>
                  <td>
                    <a onClick={() => showSensorsList('alreadyInserted')}>
                      {t(
                        showSensorList === 'alreadyInserted'
                          ? 'HIDE_DETAILS'
                          : 'SHOW_DETAILS'
                      )}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th>{t('SKIPPED_SENSORS')}</th>
                  <td>{importOverView.overviewCounts.skipped}</td>
                  <td>
                    {importOverView.overviewCounts.skipped > 0 && (
                      <a
                        onClick={() =>
                          setShowSkippedDetails(!showSkippedDetails)
                        }
                      >
                        {t(
                          showSkippedDetails ? 'HIDE_DETAILS' : 'SHOW_DETAILS'
                        )}
                      </a>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            {showSensorList && (
              <table
                className="no-padding default"
                style={{ marginTop: '1.5em' }}
              >
                <thead>
                  <tr>
                    <th>{t('IMPORTED_SENSORS_LIST')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {showSensorList === 'inserted' && (
                      <td>
                        {importOverView?.overview?.inserted
                          .map((s: SensorTemp) => s.sensor_id)
                          .join(', ')}
                      </td>
                    )}
                    {showSensorList === 'updated' && (
                      <td>
                        {importOverView?.overview?.updated
                          .map((s: SensorTemp) => s.sensor_id)
                          .join(', ')}
                      </td>
                    )}
                    {showSensorList === 'alreadyInserted' && (
                      <td>
                        {importOverView?.overview?.alreadyInserted
                          .map((s: SensorTemp) => s.sensor_id)
                          .join(', ')}
                      </td>
                    )}
                  </tr>
                </tbody>
              </table>
            )}
            {showSkippedDetails && importOverView.overviewCounts.skipped > 0 && (
              <div style={{ marginTop: '1.5em' }}>
                <table className="no-padding default">
                  <thead>
                    <tr>
                      <th>{t('SENSOR_ID')}</th>
                      <th>{t('IMPORT_SENSORS_ERRORS')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {importOverView.overview.skipped.map((skipped: any) => {
                      return (
                        <tr key={skipped.sensorId}>
                          <td>{skipped.sensorId}</td>
                          <td>
                            <ul>
                              {skipped.errors.map((error: string) => {
                                return (
                                  <li
                                    key={`${skipped.sensorId}-${error}`}
                                    style={{ color: 'red' }}
                                  >
                                    {error}
                                  </li>
                                );
                              })}
                            </ul>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </CardContent>
      <CardActions>
        <Button
          style={{ marginLeft: 10, marginBottom: 10 }}
          variant="contained"
          type="submit"
          onClick={() => importCSV()}
          disabled={
            selectedProductType === undefined ||
            csvFile === undefined ||
            invalidCsvFile
          }
        >
          {t('IMPORT')}
        </Button>
      </CardActions>
    </Card>
  );
};

export default ImportCsv;
